import { datadogRum } from '@datadog/browser-rum';

import { getDatadogUserFromSessionUser, SESSION_REPLAY_MASK_LEVEL } from '@motorway/mw-dealer-shared-components/config';
import type { DatadogRumProps } from '@motorway/mw-dealer-shared-components/types';

import getEnvironmentName from 'Utilities/helpers/getEnvironmentName';

const motorwayCloudUrls = /^https:\/\/[^.]+\.motorway\.cloud/;
// Some URLs produce CORS errors when we try to trace them, so we need to exclude them.
// We also may want to keep some of these URLs excluded, until we're sure they aren't a concern for PII.
const motorwayUrlsWithExclusions = /^https:\/\/[^.]+\.motorway\.co\.uk(?![^?]*?(payment|snowplow|sellerdetails)).*$/;
const allowedTracingUrls = [motorwayUrlsWithExclusions, motorwayCloudUrls];

export const initDatadogRum = ({ isDatadogRumTracingEnabled, release, user }: DatadogRumProps): void => {
	const userIdentity = getDatadogUserFromSessionUser(user);

	datadogRum.init({
		...(isDatadogRumTracingEnabled ? { allowedTracingUrls } : {}),
		applicationId: '2326e377-b46a-458c-9bab-7bb3c702e1cf',
		clientToken: 'pub789b1c29e875a5c6e9d627b9b3f2de44',
		defaultPrivacyLevel: SESSION_REPLAY_MASK_LEVEL.maskUserInput,
		env: `${getEnvironmentName()}-client`,
		sampleRate: 100,
		service: 'dealer-webapp',
		sessionReplaySampleRate: 100,
		site: 'datadoghq.eu',
		trackFrustrations: true,
		trackInteractions: true,
		trackLongTasks: true,
		trackResources: true,
		version: release?.toLowerCase(),
	});

	datadogRum.setUser(userIdentity);
	datadogRum.startSessionReplayRecording();
};

export { applySessionReplayActionName, applySessionReplayMask } from '@motorway/mw-dealer-shared-components/config';
